(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kp-produto-nutrition"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kp-nutrition')) {
    customElements.define(
      'kp-nutrition',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.controller = new AbortController();
          const options = { signal: this.controller.signal };
          this.dialog = this.querySelector('dialog');
          const trigger = this.querySelector('[data-kp-nutrition-open]');
          const close = this.querySelector('[data-kp-nutrition-close]');
          if (!this.dialog || !trigger || !close) return;

          trigger.addEventListener(
            'click',
            () => {
              if (this.dialog.open) return;
              this.dialog.showModal();
              this.dialog.scrollTop = 0;
            },
            options
          );
          close.addEventListener('click', () => this.dialog.close(), options);
          const outside = (event) => {
            const bounds = this.dialog.getBoundingClientRect();
            return (
              event.target === this.dialog &&
              (event.clientX < bounds.left ||
                event.clientX > bounds.right ||
                event.clientY < bounds.top ||
                event.clientY > bounds.bottom)
            );
          };
          this.dialog.addEventListener(
            'pointerdown',
            (event) => {
              this.backdropPress = outside(event);
            },
            options
          );
          this.dialog.addEventListener(
            'click',
            (event) => {
              if (this.backdropPress && outside(event)) this.dialog.close();
              this.backdropPress = false;
            },
            options
          );
        }

        disconnectedCallback() {
          if (this.dialog?.open) this.dialog.close();
          this.controller?.abort();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
